import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  input,
  model,
} from '@angular/core';
import type { FormValueControl } from '@angular/forms/signals';
import { UiFieldControl } from '../../../basics/ui-field-control';
import { getRandomId } from '../../../utils/get-random-id';
import { ValidationErrorUIComponent } from '../validation-error/validation-error.component';

@Component({
  selector: 'fr8bot-ui-textarea-field',
  imports: [ValidationErrorUIComponent],
  templateUrl: './textarea-field.component.html',
  styleUrl: './textarea-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextareaFieldComponent
  extends UiFieldControl
  implements FormValueControl<string | null>
{
  readonly value = model<string | null>(null);

  readonly label = input<string | null>(null);
  readonly placeholder = input('');
  /** Bound by `[formField]` from the schema's `maxLength` / `MAX_LENGTH`; shows the counter. */
  readonly maxLength = input<number | undefined>(undefined);

  protected readonly length = computed(() => this.value()?.length ?? 0);
  protected readonly isOverLimit = computed(() => {
    const max = this.maxLength();
    return max !== undefined && this.length() > max;
  });

  protected readonly errorRef = contentChild(ValidationErrorUIComponent);
  protected readonly id = getRandomId('textarea');
}
